import { classes } from "@/utils"
import { ComponentChildren } from "preact"
import { UserState } from "src/auth/user.tsx"

export function ProfileSettings() {
  const email = UserState.use(u => u!.email)
  return <Row title="Email Address">{email}</Row>
}

interface SectionProps {
  children: ComponentChildren
  title: string
  class?: string
  action?: ComponentChildren
}

export function Section({ children, title, action, ...props }: SectionProps) {
  return (
    <div class={classes("pt-4", props.class)}>
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-semibold leading-7 text-gray-900">{title}</h2>
        {action}
      </div>
      <dl class="space-y-3 divide-y divide-gray-100 text-sm leading-6">{children}</dl>
    </div>
  )
}

interface RowProps {
  children: ComponentChildren
  title: string
}

export function Row({ children, title, ...props }: RowProps) {
  return (
    <div class="pt-3 sm:flex">
      <dt class="text-gray-900 sm:w-64 sm:flex-none sm:pr-6">{title}</dt>
      <dd class="flex justify-end gap-x-6 sm:flex-auto">{children}</dd>
    </div>
  )
}
